<template>
  <div class="products-and-footer-eng">
    <scmenueng></scmenueng>
    <machineseng></machineseng>
    <hr>
    <bigankiserieseng></bigankiserieseng>
    <hr>
    <swserieseng></swserieseng>
    <hr>
    <plserieseng></plserieseng>
    <hr>
    <acserieseng></acserieseng>
    <hr>
    <hmserieseng></hmserieseng>
    <hr>
    <drmedicserieseng></drmedicserieseng>
    <hr>
    <kilominuseng></kilominuseng>
    <hr>
    <!-- <sunkissedseries></sunkissedseries> -->
    <scfootereng></scfootereng>
  </div>
</template>

<script>
 export default {
   name: 'productseng',
   components: {
     scmenueng: () => import('../components/scMenuEng.vue'),
     machineseng: () => import('../components/MachinesEng.vue'),
     swserieseng: () => import('../components/SWseriesEng.vue'),
     plserieseng: () => import('../components/PLseriesEng.vue'),
     acserieseng: () => import('../components/ACseriesEng.vue'),
     hmserieseng: () => import('../components/HMseriesEng.vue'),
     sunkissedseries: () => import('../components/SUNKISSEDseries.vue'),
     bigankiserieseng: () => import('../components/BigankiSeriesEng.vue'),
     drmedicserieseng: () => import('../components/DrMedicSeriesEng.vue'),
     kilominuseng: () => import('../components/KiloMinusEng.vue'),
     scfootereng: () => import('../components/scFooterEng.vue')
   },
 }
</script>


<style lang="scss">
 #scmenueng {
   /*    padding-top: -200px; */
   /*    margin-top: -10px; */
   /*    z-index: 100; */
 }
 #scmenu {
   display: none;
 }
 #scmenueng .menu-section {
   position: absolute;
   /*     margin-top: 42px; */
   margin-left: -30px;
   z-index: 11;
 }
 $page-width: 960px;
 .products-and-footer-eng {
   margin-top: 80px;
 }
 @media (min-width: 601px) {
   .products-and-footer-eng {
     /*       margin-top: 80px; */
     margin-top: 0px;
     /* to deal with floating menu*/
   }
 }


</style>
